<template>
  <div v-if="selectedKeyword && selectedKeyword.id != null" class="keyword-occurrence-bar">
    <span class="keyword-occurrence-bar__keyword">{{ selectedKeyword.value }}</span>
    <span class="keyword-occurrence-bar__count number-monospace">
      {{ $t('page.analysis.keyword-navigator.occurrence', { index: keywordIndex, count: keywordOccurrences }) }}
    </span>
    <template v-if="keywordOccurrences > 1">
      <BaseRoundButton
        icon="chevron-left"
        :size="36"
        is-transparent
        :disabled="keywordIndex <= 1"
        :aria-label="$t('actions.previous')"
        @click.native="request('previous')"
      />
      <BaseRoundButton
        icon="chevron-right"
        :size="36"
        is-transparent
        :disabled="keywordIndex >= keywordOccurrences"
        :aria-label="$t('actions.next')"
        @click.native="request('next')"
      />
    </template>
    <button type="button" class="keyword-occurrence-bar__done" @click="request('done')">
      {{ $t('page.analysis.keyword-navigator.done') }}
    </button>
  </div>
</template>

<script>
import BaseRoundButton from '@/components/base/BaseRoundButton.vue';
import { bus } from '@/main';
import { mapGetters } from 'vuex';

// The selected keyword's occurrences over the document, while its panel is out of sight (phones and
// tablets). Its buttons drive that panel (KeywordNavigation), which knows where it is among them.
export default {
  name: 'KeywordOccurrenceBar',
  components: { BaseRoundButton },
  computed: {
    ...mapGetters('opportunityKeywordSearch', ['selectedKeyword', 'keywordIndex', 'keywordOccurrences']),
  },
  methods: {
    request(action) {
      bus.$emit('keyword-occurrence', action);
    },
  },
};
</script>

<style lang="scss">
.keyword-occurrence-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 44px;
  padding: 0 4px 0 12px;
  background: $color-white;
  border-radius: $radius-full;
  box-shadow: $shadow-dropdown;

  &__keyword {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
  }

  &__count {
    flex: none;
    color: $color-neutral;
    font-size: 14px;
  }

  &__done {
    flex: none;
    min-height: 44px;
    padding: 0 12px;
    color: $color-accent;
    font-weight: 600;
  }
}
</style>
